<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#DAE2FB">
        <g>
          <g>
            <g>
              <path
                d="M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 2C4.686 2 2 4.686 2 8s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6z"
                transform="translate(-520 -1243) translate(496 948) translate(24 128) translate(0 150) translate(0 17)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'EmptyRadioboxIcon',
  props: {
    height: VueTypes.string.def('24'),
    width: VueTypes.string.def('24'),
  },
};
</script>

<style lang="scss"></style>
